import * as turf from '@turf/turf'
import type { Feature, GeoJsonProperties, Point } from 'geojson'
import {
  getProgressPercentage,
  type RouteCoordinate,
} from '../../logic/routeUtils'

export { getProgressPercentage }

export function calculateRouteSegment(
  progressPercent: number,
  routeCoordinates: RouteCoordinate[],
): Feature<Point, GeoJsonProperties> {
  const routeLine = turf.lineString(routeCoordinates)
  const clampedProgress = Math.max(0, Math.min(progressPercent, 100))

  if (clampedProgress >= 100) {
    const lastCoord = routeLine.geometry.coordinates[routeLine.geometry.coordinates.length - 1]!
    return turf.nearestPointOnLine(routeLine, turf.point(lastCoord))
  }

  const alongPoint = turf.along(routeLine, (clampedProgress / 100) * turf.length(routeLine), {
    units: 'kilometers',
  })
  return turf.nearestPointOnLine(routeLine, alongPoint)
}

export function calculateBounds(
  points: Feature<Point, GeoJsonProperties>[],
): [[number, number], [number, number]] {
  const collection = turf.featureCollection(points)
  const bbox = turf.bbox(collection)
  return [
    [bbox[0], bbox[1]],
    [bbox[2], bbox[3]],
  ]
}

export function buildRouteFeatures(
  yourPoint: Feature<Point, GeoJsonProperties>,
  routeCoordinates: RouteCoordinate[],
) {
  const routeLine = turf.lineString(routeCoordinates)
  const index = yourPoint.properties?.index ?? 0

  const yourRoute = {
    type: 'Feature' as const,
    geometry: {
      type: 'LineString' as const,
      coordinates: [
        ...routeLine.geometry.coordinates.slice(0, index + 1),
        yourPoint.geometry.coordinates,
      ],
    },
  }

  const remainingRoute = {
    type: 'Feature' as const,
    geometry: {
      type: 'LineString' as const,
      coordinates: [yourPoint.geometry.coordinates, ...routeLine.geometry.coordinates.slice(index + 1)],
    },
  }

  return { yourRoute, remainingRoute }
}
